import React from "react";

const Faculty = () => {
	return (
		<div className="faculty">
			<div className="container">
				<div className="title">Computer Science Faculty </div>
				<div className="card">
					<div className="text">
						<div className="title"> Computer Science Department</div>
						<div className="subtitle">
							Computer Science department is all about the efforts of our hard-working teachers. The whole
							faculty is an example of perseverance and passion towards teaching and making students sound
							in the field of technology.
						</div>
					</div>
					<div className="image">
						<img src="/assets/faculty.jpg" alt="techarena" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Faculty;
